import { Link } from "react-router-dom";
import '../styles/Hero.css';

const Hero = () => {
    return (
        <section className="heroContainer">
            <div className="km-container hero-inner km-enter">
                <p className="km-eyebrow">SAHPRA licensing consultancy · South Africa</p>
                <h1 className="hero-title">SAHPRA Medical Device Licensing Made Simple</h1>
                <p className="hero-lead">
                    Expert guidance for medical device distributors, wholesalers and manufacturers,
                    from document preparation through to SAHPRA approval.
                </p>
                <div className="hero-actions">
                    <Link className="km-btn km-btn--accent" to="/quote">Request a Quote</Link>
                    <Link className="km-btn km-btn--outlineLight" to={{ hash: "#licences" }}>Explore Licences</Link>
                </div>
                <ul className="hero-points">
                    <li>No account needed</li>
                    <li>Response within 1–2 business days</li>
                    <li>10+ years of industry experience</li>
                </ul>
            </div>
        </section>
    );
};

export default Hero;
